import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BentoComponent} from "./bento.component";
import {InlineSVGModule} from "ng-inline-svg-2";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [BentoComponent],
  exports: [BentoComponent],
  imports: [
    CommonModule,
    InlineSVGModule,
    TranslateModule
  ]
})
export class BentoModule {
}
